import $api from "../http";
import { IChangePasswordModel, IUpdateUserModel, IUser } from "../models/User";
import {
  IPaymentMethod,
  IPaymentMethodCreate,
  IPaymentMethodUpdate,
} from "../models/PaymentMethod";

class UserServiceClass {
  async getUserByEmail(email: string) {
    return await $api.get<IUser>(`api/users/by-email/${email}`);
  }

  async deleteUser() {
    return await $api.delete<{}>("api/users/delete-account");
  }

  async changePassword(id: string | null, model: IChangePasswordModel) {
    return await $api.put<boolean>(`api/users/change-password/${id}`, model);
  }

  async updateProfile(data: IUpdateUserModel) {
    const { id, ...all } = data;
    return await $api.put<IUser>(`api/users/update/${id}`, all);
  }

  async changeProfileImage(id: string, formData: FormData) {
    return await $api.post<{ profileImagePath: string }>(`api/users/upload-image/${id}`, formData);
  }

  // Stripe payment methods
  async attachPaymentMethod(model: IPaymentMethodCreate) {
    return await $api.post<boolean>(`api/users/payment-method/attach`, model);
  }

  async getAllPaymentMethod(userId: string) {
    return await $api.get<IPaymentMethod[]>(`api/users/payment-methods/get-for-customer/${userId}`);
  }

  async detachPaymentMethod(paymentMethodId: string, userId: string) {
    return await $api.post<boolean>(`api/users/payment-method/detach`, { paymentMethodId, userId });
  }

  async changeDefaultPaymentMethod(paymentMethodId: string, userId: string) {
    return await $api.put<boolean>(`api/users/payment-methods/change-default/${userId}`, {
      paymentMethodId,
    });
  }

  async getPaymentMethodById(paymentMethodId: string, userId: string) {
    return await $api.get<IPaymentMethod>(
      `api/users/payment-method/get-payment-method/${paymentMethodId}/${userId}`
    );
  }

  async updatePaymentMethodById(paymentMethodId: string, model: IPaymentMethodUpdate) {
    return await $api.put<boolean>(`api/users/payment-method/update/${paymentMethodId}`, model);
  }
}

export const UserService = new UserServiceClass();
